export default {
  SET_ACTIVE_SIDEBAR_FOR_GRID: (state, payload) => {
    state.activeSidebarForGrid = Object.assign({}, payload);
  },
  /**
   * FireStoreとのデータの整合性を取るために使用する共通セッター
   * payload: { map_id: [マップID], [更新したいキー]: [更新したい値] }
   * を引数で渡す
   */
  UPDATE_GRID_MAP_SETTINGS: (state, payload) => {
    if (!payload.map_id) return;
    const index = state.allGridMapSettings.findIndex(
      (setting) => setting.map_id === payload.map_id,
    );
    if (index === -1) {
      state.allGridMapSettings.push(payload);
    } else {
      const nextGridMapSetting = {
        ...state.allGridMapSettings[index],
        ...payload,
      };
      // 配列の変更をVueに拾わせるためspliceをしている
      state.allGridMapSettings.splice(index, 1, nextGridMapSetting);
    }
  },
  /** グリッド用：最後に追跡した座標とmapId */
  UPDATE_LAST_TRACKING_POSITION: (state, payload) => {
    state.lastTrackingPosition = Object.assign({}, payload);
  },
  SET_EXPIRED_POPUP_FOR_GRID: (state, payload) => {
    state.expiredPopupForGrid = payload;
  },
  RESET_STATE(state, data) {
    Object.assign(state, data);
  },
};
